/**
 * Spend by Service Chart
 * Horizontal bar chart showing GCP spend by service
 */

import BarChart from '@/components/charts/BarChart';
import type { ServiceSpend } from '../types';

interface SpendByServiceChartProps {
  data: ServiceSpend[];
  currency: string;
}

export function SpendByServiceChart({ data, currency }: SpendByServiceChartProps) {
  // Sort by current month spend and take top 10
  const chartData = data
    .slice()
    .sort((a, b) => b.currentMonth - a.currentMonth)
    .slice(0, 10)
    .map((item) => ({
      name: item.serviceName,
      value: item.currentMonth,
      previousValue: item.previousMonth,
    }));

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Spend by Service</h3>
      <div className="text-sm text-gray-500 mb-4">Top 10 services by current month spend</div>
      <BarChart
        data={chartData}
        dataKey="value"
        xAxisKey="name"
        height={350}
        horizontal
        barSize={16}
        colorByValue
      />
      <div className="mt-4 text-xs text-gray-500 text-right">
        Values in {currency}
      </div>
    </div>
  );
}
